import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { Address as OldAddress } from "@models";
import { Time } from "@models/time";

export interface AssetWalletAddress {
	readonly address: string;
	readonly cryptoCoinId?: number; // TODO unused?
	readonly generatedAt: Time; // TODO "Time" model shouldn't be replaced by some simple interface?
	readonly lastUpdated: Time; // TODO "Time" model shouldn't be replaced by some simple interface?
	readonly name?: string; // TODO unused?
	readonly isEnabled: boolean;
	readonly validityRemaining: number;
	readonly walletId: string;
	readonly destinationTag: string;
}

export class AssetWalletAddressAdapter extends BaseAdapter<OldAddress, AssetWalletAddress> {
	public adapt(item: OldAddress): AssetWalletAddress {
		if (!item) {
			return null;
		}

		return {
			address: item.getAddress(),
			generatedAt: item.getGeneratedAt(),
			lastUpdated: item.getLastUpdated(),
			isEnabled: !item.isDisabled(),
			validityRemaining: item.getValidity(),
			walletId: item.getWalletId(),
			destinationTag: item.getDestinationTag()
		};
	}
}
